import gql from 'graphql-tag';

export const ListApplicationsQuery = gql`
  query ListApplicationsQuery {
    applications {
      id
      applicationNumber
      name
      _Ebb_DwellingId
      _Ebb_DwellingId_Formatted
      _Ebb_OwnerId
      _Ebb_OwnerId_Formatted
      _Ebb_ProgramCycleId
      _Ebb_ProgramCycleId_Formatted
      _Ebb_PolicyId
      programType
      stageCode
      stageCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      acceptedDate
      preRetrofitDue
      preRetrofitPass
      postRetrofitDue
      postRetrofitPass
      applicationStatus
      applicationStatusOptionSet
      extensionDate
      eventPreliminaryReviewApproval
      eventPreliminaryReview
      eventFemaReview
      eventApplicationSubmitted
      eventMitigationReviewSubmitted
      eventFinancialReviewSubmitted
      _Ebb_ContractorId
      _Ebb_ContractorId_Formatted
      contractorTypeCode
      contractorTypeCodeOptionSet
      contractorPermissionsCode
      contractorPermissionsCodeOptionSet
      contractorInvitationCode
      contractorInvitationCodeOptionSet
      contractorInvitationDate
      permitIssuedDate
      permitIssuer
      permitNumber
      permitPlanCode
      permitPlanCodeOptionSet
      w9DataSubmitted
      paymentDataSubmitted
      retrofitConstructionStartDate
      retrofitConstructionEndDate
      retrofitConstructionNumberOfDays
      itemsPendingRollup
      itemsUpdatedRollup
      itemsRejectedRollup
      submissionRejection
      inspectorFullname
      inspectionDate
      ebbInspectionStatus
      ebbInspectorName
      ebbInspectionDate
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
      }
      contractor {
        id
        businessName
      }
      dwelling {
        homeownerOccupied
      }
    }
  }
`;

export const ListApplicationsProgramCycleQuery = gql`
  query ListApplicationsProgramCycleQuery {
    applications {
      id
      applicationNumber
      name
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
      }
      dwelling {
        homeownerOccupied
      }
    }
  }
`;

export const ListInspectionCompleteApplicationsQuery = gql`
  query ListApplicationsQuery {
    applications(type: "inspectionComplete") {
      id
      applicationNumber
      name
      _Ebb_DwellingId
      _Ebb_DwellingId_Formatted
      _Ebb_OwnerId
      _Ebb_OwnerId_Formatted
      _Ebb_ProgramCycleId
      _Ebb_ProgramCycleId_Formatted
      _Ebb_PolicyId
      programType
      stageCode
      stageCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      acceptedDate
      preRetrofitDue
      preRetrofitPass
      postRetrofitDue
      postRetrofitPass
      eventPreliminaryReview
      eventFemaReview
      applicationStatus
      applicationStatusOptionSet
      extensionDate
      eventApplicationSubmitted
      eventMitigationReviewSubmitted
      eventFinancialReviewSubmitted
      _Ebb_ContractorId
      _Ebb_ContractorId_Formatted
      contractorTypeCode
      contractorTypeCodeOptionSet
      contractorPermissionsCode
      contractorPermissionsCodeOptionSet
      contractorInvitationCode
      contractorInvitationCodeOptionSet
      contractorInvitationDate
      permitIssuedDate
      permitIssuer
      permitNumber
      permitPlanCode
      permitPlanCodeOptionSet
      w9DataSubmitted
      paymentDataSubmitted
      retrofitConstructionStartDate
      retrofitConstructionEndDate
      retrofitConstructionNumberOfDays
      itemsPendingRollup
      itemsUpdatedRollup
      itemsRejectedRollup
      submissionRejection
      inspectorFullname
      inspectionDate
      ebbInspectionStatus
      ebbInspectorName
      ebbInspectionDate
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
      }
      contractor {
        id
        businessName
      }
      dwelling {
        homeownerOccupied
      }
    }
  }
`;

export const ListApplicationsForMultipleQuery = gql`
  query ListApplicationsQuery {
    applications {
      stateCode
      statusCode
      _Ebb_ProgramCycleId
    }
  	dwellings {
      stateCode
      statusCode
      _Ebb_ProgramCycleId
    }
  }
`;

export const GetApplicationByIdQuery = gql`
         query GetApplicationByIdQuery($id: String) {
           application(id: $id) {
             id
             applicationNumber
             name
             _Ebb_DwellingId
             _Ebb_DwellingId_Formatted
             _Ebb_OwnerId
             _Ebb_OwnerId_Formatted
             _Ebb_ProgramCycleId
             _Ebb_ProgramCycleId_Formatted
             _Ebb_PolicyId
             programType
             programRulesAcknowledged
             stageCode
             stageCodeOptionSet
             stateCode
             stateCodeOptionSet
             statusCode
             statusCodeOptionSet
             acceptedDate
             preRetrofitDue
             preRetrofitPass
             postRetrofitDue
             postRetrofitPass
             eventFemaReviewOptionSet
             applicationStatus
             applicationStatusOptionSet
             extensionDate
             eventPreliminaryReviewApproval
             eventPreliminaryReview
             eventFemaReview
             eventApplicationSubmitted
             eventMitigationReviewSubmitted
             eventFinancialReviewSubmitted
             _Ebb_ContractorId
             _Ebb_ContractorId_Formatted
             contractorTypeCode
             contractorTypeCodeOptionSet
             contractorPermissionsCode
             contractorPermissionsCodeOptionSet
             contractorInvitationCode
             contractorInvitationCodeOptionSet
             contractorInvitationDate
             contractorBidAmount1
             contractorBidAmount1Selected
             contractorBidAmount2
             contractorBidReason
             permitIssuedDate
             permitIssuer
             permitNumber
             permitPlanCode
             permitPlanCodeOptionSet
             w9DataSubmitted
             paymentDataSubmitted
             retrofitConstructionStartDate
             retrofitConstructionEndDate
             retrofitConstructionNumberOfDays
             itemsPendingRollup
             itemsUpdatedRollup
             itemsRejectedRollup
             submissionRejection
             retrofitType
             retrofitTypeOptionSet
             engineeredSolutionType
             engineeredSolutionTypeOptionSet
             permitCost
             materialCost
             laborCost
             overheadProfitCost
             bidInvoiceCost
             inspectorFullname
             inspectionDate
             ebbInspectionStatus
             ebbInspectorName
             ebbInspectionDate
             sGStatus
             sGStatusOptionSet
             sGBidInvoiceNeeded
             sGBidInvoiceNeededHomeowner
             sGBidInvoiceSubmitted
             sGPermitReceiptSubmitted
             sGPermitReceiptSubmittedHomeowner
             envelopeOkToVerify
             envelopeId
             sGSubmittedDate
             sGmaxrequests
             sGHomeownerPaidPermit
             sGPermitPaidDate
             sGBuildingPermitProcessing
             sGBidInvoiceProcessing
             drvEligible
             approvalTasks {
               id
               name
               stageCode
               stageCodeOptionSet
               stateCode
               stateCodeOptionSet
               statusCode
               statusCodeOptionSet
               uiTabName
               userPrompt
               progressReport
               dueDateSuggested
               itemCountTotal
               itemCountDone
               approvalTaskItems {
                 id
                 name
                 typeCode
                 typeCodeOptionSet
                 stateCode
                 stateCodeOptionSet
                 statusCode
                 statusCodeOptionSet
                 reasonWhy
                 allowRecordCreation
                 isRequired
                 payloadTypeCode
                 payloadTypeCodeOptionSet
                 payloadName
                 payload
                 submitDate
                 submissionReject
                 ebbModifiedDate
                 ebbModifiedByTypeOptionSet
                 approvalTaskItemKey
                 createdOn
                 attempt
                 taxYear
                 annotations {
                   id
                   fileName
                   modifiedOn
                   noteText
                 }
                 recipients {
                   id
                   clientId
                   documentId
                   recipientId
                   primary
                   name
                   nameFirst
                   nameMiddle
                   nameLast
                   verificationStatus
                   verificationStatusDescription
                   verificationSubmitted
                   verificationCompleted
                   verificationErrorDate
                   viewUrl
                   statusCode
                   signingStatus
                   signingDate
                   recipientStatus
                   recipientStatusOptionSet
                   _Ebb_ApprovalTaskItemId
                 }
               }
             }
             programCycle {
               multipleBidsRequired
               bidMustSubmitDoc
               homeownerOccupied
               contractorAllowManual
             }
             policy {
               expirationDate
             }
             contractor {
               id
               businessName
               contractorManualEntry
               fullName
               contractorInDirectory
               essContractorInDirectory
             }
             contractorHireHistorys {
               createdOn
               contractorid
               contractorBusinessName
             }
             applicationEvents {
               createdOn
               eventType
               eventDescription
             }
           }
         }
       `;
